import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { adminRoutesURLs } from '../../constants/routes';
import AdvertisingPage from '../../pagesAdmin/AdvertisingPage/AdvertisingPage';
import EmployersPage from '../../pagesAdmin/EmployersPage/EmployersPage';
import WorkplacesPage from '../../pagesAdmin/WorkplacesPage/WorkplacesPage';
import UserAreaPage from '../../pagesAdmin/UserAreaPage/UserAreaPage';
import SectionServicesPage from '../../pagesAdmin/SectionServicesPage/SectionServicesPage';
import BranchesPage from '../../pagesAdmin/BranchesPage/BranchesPage';
import TerminalAppearancePage from '../../pagesAdmin/TerminalAppearancePage/TerminalAppearancePage';
import TabloSettingsPage from '../../pagesAdmin/TabloSettingsPage/TabloSettingsPage';
import RatingSettingsPage from '../../pagesAdmin/RatingSettingsPage/RatingSettingsPage';
import MisSettingsPage from '../../pagesAdmin/MisSettingsPage/MisSettingsPage';
import QueueScenarioSettingsPage from '../../pagesAdmin/QueueScenarioSettingsPage/QueueScenarioSettingsPage';
import CurrentServicesStatusPage from '../../pagesAdmin/AnalyticsAndReportsPages/CurrentServicesStatusPage/CurrentServicesStatusPage';
import ServicesPage from '../../pagesAdmin/AnalyticsAndReportsPages/ServicesPage/ServicesPage';
import VisitorsPage from '../../pagesAdmin/AnalyticsAndReportsPages/VisitorsPage/VisitorsPage';
import EmployersReportsPage from '../../pagesAdmin/AnalyticsAndReportsPages/EmployersReportsPage/EmployersReportsPage';
import QualityReportPage from '../../pagesAdmin/AnalyticsAndReportsPages/QualityReportPage/QualityReportPage';
import AuditPage from '../../pagesAdmin/AuditPage/AuditPage';
// import Page404 from '../../pagesAdmin/Page404/Page404';

const AdminRoutes: FC = () => {
  const {
    branches,
    sectionServices,
    workplaces,
    employers,
    audit,
    advertising,
    userArea,
    terminalAppearance,
    tabloSettings,
    ratingSettings,
    misSettings,
    queueScenarioSettings
  } = adminRoutesURLs;
  const {
    analyticsAndReportsBase,
    services,
    employersReports,
    visitors,
    currentServicesStatus,
    qualityReport
  } = adminRoutesURLs.analyticsAndReports;

  return (
    <div>
      <Routes>
        <Route path={branches} element={<BranchesPage />} />
        <Route path={sectionServices} element={<SectionServicesPage />} />
        <Route path={workplaces} element={<WorkplacesPage />} />
        <Route path={employers} element={<EmployersPage />} />
        <Route path={audit} element={<AuditPage />} />
        <Route path={advertising} element={<AdvertisingPage />} />
        <Route path={terminalAppearance} element={<TerminalAppearancePage />} />
        <Route path={tabloSettings} element={<TabloSettingsPage />} />
        <Route path={ratingSettings} element={<RatingSettingsPage />} />
        <Route path={misSettings} element={<MisSettingsPage />} />
        <Route path={queueScenarioSettings} element={<QueueScenarioSettingsPage />} />
        <Route path={userArea} element={<UserAreaPage />} />
        <Route path={`${analyticsAndReportsBase}/`}>
          <Route path={services} element={<ServicesPage />} />
          <Route path={employersReports} element={<EmployersReportsPage />} />
          <Route path={visitors} element={<VisitorsPage />} />
          <Route path={currentServicesStatus} element={<CurrentServicesStatusPage />} />
          <Route path={qualityReport} element={<QualityReportPage />} />
        </Route>
        <Route path="/*" element={null} />
      </Routes>
    </div>
  );
};

export default AdminRoutes;
